import { useState } from 'react'
import type { FormEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { Snackbar } from '../../../components/feedback/Snackbar'

const ZAPIER_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/27366398/uv3iz4k/'

export function WaitlistForm() {
  const { t } = useTranslation()
  const [successSignal, setSuccessSignal] = useState(0)

  const showSuccessMessage = () => {
    setSuccessSignal((current) => current + 1)
  }

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)
    const email = String(formData.get('email') ?? '').trim()

    if (!email) {
      return
    }

    try {
      await fetch(ZAPIER_WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: new URLSearchParams({ email }),
      })
      form.reset()
      showSuccessMessage()
    } catch (error) {
      console.error('Waitlist submit failed', error)
    }
  }

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="mx-auto mt-12 flex w-full max-w-[560px] flex-col gap-3 rounded-xl border border-[var(--color-outline-variant)]/70 bg-[var(--color-surface-container-lowest)] p-2 sm:flex-row sm:items-center"
      >
        <input
          type="email"
          name="email"
          required
          placeholder={t('comingSoon.hero.emailPlaceholder')}
          className="h-11 flex-1 rounded-lg border border-transparent bg-transparent px-4 text-sm text-[var(--color-on-surface)] outline-none transition-colors placeholder:text-[var(--color-on-surface-variant)]"
        />

        <button
          type="submit"
          className="h-11 rounded-lg bg-black px-6 text-sm font-medium text-white transition-colors hover:bg-[#1f1f1f]"
        >
          {t('comingSoon.hero.joinWaitlist')}
        </button>
      </form>

      <Snackbar message={t('comingSoon.hero.waitlistSuccess')} trigger={successSignal} />
    </>
  )
}
